import { defineMessages } from 'react-intl'

export default defineMessages({
  error: {
    id: 'containers.SchedulingPollDetailPage.error',
    defaultMessage: 'Error: {error}',
  },
  requestNotFound: {
    id: 'containers.SchedulingPollDetailPage.requestNotFound',
    defaultMessage: 'Request not found',
  },
  open: {
    id: 'containers.SchedulingPollDetailPage.open',
    defaultMessage: 'Open',
  },
  closed: {
    id: 'containers.SchedulingPollDetailPage.closed',
    defaultMessage: 'Closed',
  },
  participantLink: {
    id: 'containers.SchedulingPollDetailPage.participantLink',
    defaultMessage: 'Participant Link:',
  },
  copy: {
    id: 'containers.SchedulingPollDetailPage.copy',
    defaultMessage: 'Copy',
  },
  timeSlots: {
    id: 'containers.SchedulingPollDetailPage.timeSlots',
    defaultMessage: 'Time Slots',
  },
  responses: {
    id: 'containers.SchedulingPollDetailPage.responses',
    defaultMessage: 'Responses',
  },
  created: {
    id: 'containers.SchedulingPollDetailPage.created',
    defaultMessage: 'Created',
  },
  availabilityOverview: {
    id: 'containers.SchedulingPollDetailPage.availabilityOverview',
    defaultMessage: 'Availability Overview',
  },
  timesShownIn: {
    id: 'containers.SchedulingPollDetailPage.timesShownIn',
    defaultMessage: 'Times shown in {timezone}',
  },
  best: {
    id: 'containers.SchedulingPollDetailPage.best',
    defaultMessage: '★ Best',
  },
  available: {
    id: 'containers.SchedulingPollDetailPage.available',
    defaultMessage: 'Available',
  },
  maybe: {
    id: 'containers.SchedulingPollDetailPage.maybe',
    defaultMessage: 'Maybe',
  },
  unavailable: {
    id: 'containers.SchedulingPollDetailPage.unavailable',
    defaultMessage: 'Unavailable',
  },
  participantResponses: {
    id: 'containers.SchedulingPollDetailPage.participantResponses',
    defaultMessage: 'Participant Responses ({count})',
  },
  noResponses: {
    id: 'containers.SchedulingPollDetailPage.noResponses',
    defaultMessage: 'No participant responses yet',
  },
  noTimeSlots: {
    id: 'containers.SchedulingPollDetailPage.noTimeSlots',
    defaultMessage: 'No time slots defined',
  },
  participantResponsesTable: {
    id: 'containers.SchedulingPollDetailPage.participantResponsesTable',
    defaultMessage: 'Participant Responses ({count})',
  },
  name: {
    id: 'containers.SchedulingPollDetailPage.name',
    defaultMessage: 'Name',
  },
  email: {
    id: 'containers.SchedulingPollDetailPage.email',
    defaultMessage: 'Email',
  },
  submitted: {
    id: 'containers.SchedulingPollDetailPage.submitted',
    defaultMessage: 'Submitted',
  },
  closePoll: {
    id: 'containers.SchedulingPollDetailPage.closePoll',
    defaultMessage: 'Close Poll',
  },
  finalizeNotify: {
    id: 'containers.SchedulingPollDetailPage.finalizeNotify',
    defaultMessage: 'Finalize & Notify Participants',
  },
  closePollConfirm: {
    id: 'containers.SchedulingPollDetailPage.closePollConfirm',
    defaultMessage: 'Are you sure you want to close this poll? This will stop accepting new responses without selecting a final time slot.',
  },
  pollClosedSuccess: {
    id: 'containers.SchedulingPollDetailPage.pollClosedSuccess',
    defaultMessage: 'Poll closed successfully',
  },
  closePollError: {
    id: 'containers.SchedulingPollDetailPage.closePollError',
    defaultMessage: 'Failed to close poll',
  },
  loadPollError: {
    id: 'containers.SchedulingPollDetailPage.loadPollError',
    defaultMessage: 'Failed to load scheduling poll',
  },
  linkCopied: {
    id: 'containers.SchedulingPollDetailPage.linkCopied',
    defaultMessage: 'Link copied to clipboard!',
  },
  linkCopyFailed: {
    id: 'containers.SchedulingPollDetailPage.linkCopyFailed',
    defaultMessage: 'Failed to copy link',
  },
  editPoll: {
    id: 'containers.SchedulingPollDetailPage.editPoll',
    defaultMessage: 'Edit Poll',
  },
  duplicatePoll: {
    id: 'containers.SchedulingPollDetailPage.duplicatePoll',
    defaultMessage: 'Duplicate',
  },
})
